export default "__VITE_ASSET__10710b36__"